import React, { useState } from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Alert, AlertDescription } from '../../ui';
import { api } from '../../../services/api';
import { useActionToast } from '../../../services/actionToast';
import { FormButton } from '../../buttons/FormButton';
import { InputForm } from '../../inputs/forms/InputForm';

const schema = Yup.object().shape({
  email: Yup.string().email('Informe um email válido').required('Este campo é obrigatório!'),
});

export default function RecoverForm() {
  const navigate = useNavigate();
  const [message, setMessage] = useState('');
  const [serverError, setServerError] = useState('');
  const toast = useActionToast();
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm<any>({
    resolver: yupResolver(schema),
    defaultValues: { email: '' },
  });

  const onSubmit = async (payload: { email: string }) => {
    setMessage('');
    setServerError('');
    try {
      const response = await api.post('/auth/forgot-password', payload);
      const feedback =
        response.data?.msg ||
        'Se o email estiver cadastrado, você receberá um link para redefinir sua senha.';
      setMessage(feedback);
      toast({
        status: 'success',
        title: 'Solicitação enviada',
        description: 'Verifique o email informado para continuar.',
      });
    } catch {
      const feedback = 'Não foi possível enviar a solicitação. Tente novamente.';
      setServerError(feedback);
      toast({ status: 'error', title: 'Solicitação não enviada', description: feedback });
    }
  };

  const onInvalid = () => {
    toast({
      status: 'error',
      title: 'Revise o formulário',
      description: 'Corrija os campos indicados antes de enviar.',
      id: 'recover-form-invalid',
    });
  };

  return (
    <Flex
      as="form"
      direction="column"
      gap="16px"
      onSubmit={handleSubmit(onSubmit, onInvalid)}
      noValidate
    >
      <InputForm
        name="email"
        label="Email"
        placeholder="usuario@email.com"
        register={register}
        errors={errors}
        type="email"
        autoComplete="email"
        isRequired
      />
      {message && (
        <Alert variant="success" data-testid="forgot-password-success">
          <AlertDescription>{message}</AlertDescription>
        </Alert>
      )}
      {serverError && (
        <Alert variant="error">
          <AlertDescription>{serverError}</AlertDescription>
        </Alert>
      )}
      <FormButton mt="8px" type="submit" width="100%" isLoading={isSubmitting}>
        Enviar link
      </FormButton>
      <Flex justify="center" align="center" gap="4px">
        <Text fontSize="13px" color="content.body">
          Lembrou a senha?
        </Text>
        <Button variant="link" size="sm" onClick={() => navigate('/login')}>
          Voltar para o login
        </Button>
      </Flex>
    </Flex>
  );
}
